export const categories = [
  {
    slug: "gurien-xiangchu",
    name: "闺蜜相处",
    description: "分享闺蜜之间的日常相处之道，从生活细节到情感交流，探索最舒适的姐妹相处模式。",
    icon: "ri-hearts-line",
  },
  {
    slug: "jiemei-qinggan",
    name: "姐妹情感",
    description: "记录女生之间最真挚的情感故事，那些只有姐妹才懂的心事与温暖。",
    icon: "ri-emotion-happy-line",
  },
  {
    slug: "chengzhang-jianzheng",
    name: "成长见证",
    description: "见证彼此从少女到成熟的蜕变，姐妹是人生路上最好的陪伴者与见证者。",
    icon: "ri-seedling-line",
  },
  {
    slug: "quwei-gushi",
    name: "趣味故事",
    description: "闺蜜间的搞笑日常、旅行冒险和那些令人捧腹的乌龙事件。",
    icon: "ri-magic-line",
  },
  {
    slug: "nvxing-shengya",
    name: "女性生涯",
    description: "探讨现代女性在职场、家庭与自我成长中的平衡，姐妹间的相互扶持。",
    icon: "ri-star-line",
  },
  {
    slug: "qinggan-zhinan",
    name: "情感指南",
    description: "关于友情、爱情与亲情的思考与建议，帮助女生建立健康的人际关系。",
    icon: "ri-lightbulb-line",
  },
];

export const articles = [
  {
    slug: "zhenshi-guimi-guangxi",
    title: "真正的闺蜜关系是什么样子的？这10个特征告诉你",
    excerpt: "在这个社交网络发达的时代，\"闺蜜\"这个词被用得越来越随意。但真正的闺蜜关系，远比朋友圈里的合照要深刻得多。让我们一起看看，什么样的女生关系才能被称为真正的闺蜜。",
    content: `<p>在这个社交网络发达的时代，“闺蜜”这个词被用得越来越随意。饭搭子是闺蜜，逛街伙伴是闺蜜，甚至刚认识不久的同事也能称为闺蜜。但真正的闺蜜关系，远比朋友圈里的合照要深刻得多。</p>
    <h2>一、真正的闺蜜，是彼此的避风港</h2>
    <p>当你遇到挫折、失恋、工作不顺的时候，第一个想到的人是谁？真正的闺蜜，是你可以在凌晨三点打电话给她，而她不会觉得被打扰，而是立刻清醒过来问你“怎么了”。</p>
    <p>小雅和思雨是大学同学，毕业后各自在不同城市打拼。有一次小雅加班到深夜，走出公司大楼时突然崩溃大哭。她没有打给男朋友，而是打给了远在另一个城市的思雨。思雨接起电话听到哭声，二话没说订了第二天最早的高铁票赶了过去。</p>
    <p>这就是真正的闺蜜——不需要理由，不需要预约，只要你需要，她就在。</p>
    <h2>二、真正的闺蜜，敢于说真话</h2>
    <p>当所有人都夸你那条裙子好看的时候，只有闺蜜会悄悄告诉你：“亲爱的，这条裙子真的不太适合你，显得你腰粗。”听起来扎心，但你知道她是真心为你好。</p>
    <p>真正的闺蜜不会一味迎合你，她会在你犯错时直言不讳，在你迷茫时给出最中肯的建议。因为她关心的不是你开不开心这一时，而是你的长远幸福。</p>
    <h2>三、真正的闺蜜，不会计较得失</h2>
    <p>你们之间从来不需要AA制精确到分，今天你请客明天她买单，谁多花一点谁少花一点从来不计较。生日礼物不讲究多么贵重，但一定是她花了心思去挑选的。</p>
    <p>记得有一次，林林的闺蜜阿紫为了给她准备生日惊喜，提前一个月就开始策划。她偷偷联系了林林所有重要的朋友，收集了每个人写的祝福卡片，做成了一本手工相册。林林说，那是她收到过最好的礼物。</p>
    <h2>四、10个真正闺蜜的特征</h2>
    <p>1. 她记得你说过的每一件小事，包括你小学时暗恋过的那个男生叫什么。</p>
    <p>2. 你的父母认识她，她的父母也认识你，两家人都把对方当成半个女儿。</p>
    <p>3. 你们可以一两个月不见面，但见面的一瞬间就像昨天才分开。</p>
    <p>4. 她知道你所有的黑历史，但你完全不担心她会说出去。</p>
    <p>5. 你们有自己专属的梗和语言，外人根本听不懂在说什么。</p>
    <p>6. 她会在你得意时真心为你开心，不会嫉妒也不会阴阳怪气。</p>
    <p>7. 你们吵过架，但从来没有过隔夜仇。</p>
    <p>8. 她见过你最狼狈的样子——素颜、哭泣、素面朝天——但依然觉得你很美。</p>
    <p>9. 她会帮你分析感情问题，但在你决定回头的时候依然支持你。</p>
    <p>10. 你们都知道，无论未来发生什么，这段关系都不会变。</p>`,
    category: "jiemei-qinggan",
    coverImage: "https://readdy.ai/api/search-image?query=Two%20young%20Chinese%20women%20laughing%20together%20on%20a%20sunny%20park%20bench%2C%20warm%20natural%20light%2C%20genuine%20friendship%20moment%2C%20soft%20bokeh%20background%2C%20editorial%20lifestyle%20photography%2C%20warm%20cream%20and%20blush%20tones%2C%20natural%20posing&width=800&height=500&seq=article-cover-01&orientation=landscape",
    author: "小柔",
    date: "2026-07-28",
    readTime: "8分钟",
    tags: ["闺蜜关系", "女性友谊", "情感成长"],
  },
  {
    slug: "guimi-xiangchu-zhidao",
    title: "闺蜜相处之道：维持十年友谊的5个秘诀",
    excerpt: "维持一段长达十年的闺蜜友谊并不容易，需要双方的用心经营。这里分享5个经过时间考验的相处秘诀，帮助你的姐妹情谊更加牢固。",
    content: `<p>有人说，女生的友谊像玻璃，精致却易碎。但我不这么认为。我和我的闺蜜们已经走过了十几年，中间经历了异地、工作、恋爱、结婚，但我们的关系反而越来越深厚。</p>
    <h2>秘诀一：保持定期联系，但不过度依赖</h2>
    <p>成年人的世界很忙，但真正的朋友不会因为忙碌就断了联系。我们有一个不成文的约定：每周至少有一次视频通话，哪怕只有十五分钟。</p>
    <p>但我们也很清楚，每个人都有自己的生活。不会因为对方没有秒回消息就胡思乱想，也不会因为对方和别的朋友出去玩就吃醋。成熟的友谊，是既亲密又独立。</p>
    <h2>秘诀二：学会倾听，而不是急着给建议</h2>
    <p>很多时候，闺蜜找你倾诉，并不是要你帮她解决问题。她只是需要一个能理解她、听她把话说完的人。</p>
    <p>我曾经犯过一个错误——听到闺蜜抱怨男朋友，就急着给她出主意，甚至直接说“这样的男人不分手留着过年吗”。结果她更难过了。后来我学会了先倾听，问她“你现在最需要什么？是建议还是安慰？”</p>
    <h2>秘诀三：在重要时刻，人一定要到</h2>
    <p>信息可以后面回，但有些重要时刻错过了就是错过。她的婚礼、她的孩子满月、她第一次升职庆祝、她最难过的那天……这些时刻，尽量让自己在场。</p>
    <p>我闺蜜生孩子那天，我请了假飞了三个小时过去。她看到我出现在产房门口时，眼泪直接掉下来了。那一刻我觉得，这三小时的飞行值得。</p>
    <h2>秘诀四：尊重彼此的边界</h2>
    <p>再好的闺蜜也需要边界。不过度干涉对方的感情、家庭和职业选择。可以给建议，但最终的决定要尊重。</p>
    <p>当闺蜜选择的伴侣你不太喜欢时，你可以表达关切，但不要强行拆散。当闺蜜的职业选择你觉得不够好时，你可以提供信息，但不要替她做决定。</p>
    <h2>秘诀五：一起创造新的美好回忆</h2>
    <p>不要总停留在回忆里。每年至少有一次闺蜜旅行，哪怕只是周末周边游。一起尝试新事物——学烘焙、做瑜伽、看展览、徒步。新的经历会让你们的友谊不断焕发生机。</p>
    <p>去年我们几个闺蜜一起报名了陶艺课，每周三晚上聚在一起玩泥巴，虽然做出来的东西歪歪扭扭，但那是我们最快乐的时光。</p>`,
    category: "gurien-xiangchu",
    coverImage: "https://readdy.ai/api/search-image?query=Three%20Chinese%20girlfriends%20enjoying%20afternoon%20tea%20at%20a%20cozy%20cafe%2C%20warm%20interior%20lighting%2C%20sharing%20stories%20and%20smiling%2C%20soft%20pastel%20color%20palette%2C%20lifestyle%20photography%2C%20cream%20and%20rose%20tones&width=800&height=500&seq=article-cover-02&orientation=landscape",
    author: "安琪",
    date: "2026-07-25",
    readTime: "6分钟",
    tags: ["闺蜜相处", "友谊秘诀", "姐妹情"],
  },
  {
    slug: "zhichang-nvxing-youyi",
    title: "职场女性的友谊：如何在竞争中保持姐妹情",
    excerpt: "职场中的女性友谊常常面临竞争与合作的挑战。如何在不失锋芒的同时守住姐妹情？这篇文章为职场女性提供了一份实用的友谊维护指南。",
    content: `<p>职场是一个特殊的环境。在这里，你和你的女同事既是并肩作战的伙伴，也可能在某个时刻成为竞争对手。如何在职场中建立和维持真诚的女性友谊，是很多职业女性面临的课题。</p>
    <h2>竞争不应该是友情的障碍</h2>
    <p>很多人觉得女生多了是非多，职场更是如此。但事实上，真正成熟的女性之间，完全可以在竞争中保持相互尊重和欣赏。</p>
    <p>青岚和雨桐在同一家公司的市场部，两人都是业务骨干。去年部门主管离职，她们成为了最有力的竞争者。但她们做了一个让所有人都意外的决定——她们一起去找了领导，表示无论谁晋升，都希望能继续保持合作。</p>
    <p>最终雨桐获得了晋升，但青岚不仅没有失落，反而在自己的岗位上做出了更亮眼的成绩。雨桐说，如果没有青岚的支持和建议，她可能无法胜任新的岗位。</p>
    <h2>建立职场姐妹情谊的三个原则</h2>
    <p><strong>第一，公开竞争，私下互助。</strong>在会议上可以据理力争，但下了班可以一起吐槽老板、分享资源。把竞争放在明处，把友谊放在心里。</p>
    <p><strong>第二，找到共同的敌人。</strong>开个玩笑——不是说真的要找敌人，而是找到共同的目标和挑战。两个人一起对抗项目难题、行业压力甚至性别偏见时，自然而然会成为战友。</p>
    <p><strong>第三，保持独立判断。</strong>不要因为关系好就在工作中无脑站队。真正的职场友谊，是在你做得不对时愿意私下提醒你，而不是在公开场合帮你掩饰错误。</p>
    <h2>职场闺蜜的三个禁忌</h2>
    <p>1. 不要在工作群里聊私密话题——你以为的悄悄话，可能被截图传播。</p>
    <p>2. 不要替闺蜜做工作——帮忙可以，代劳不行，这对双方都是伤害。</p>
    <p>3. 不要卷入闺蜜的办公室政治——站队一时爽，后果很难收场。</p>`,
    category: "nvxing-shengya",
    coverImage: "https://readdy.ai/api/search-image?query=Two%20professional%20Chinese%20women%20in%20modern%20office%20having%20coffee%20break%20chat%2C%20warm%20natural%20window%20light%2C%20genuine%20smiles%2C%20professional%20yet%20friendly%20atmosphere%2C%20cream%20and%20warm%20neutral%20tones&width=800&height=500&seq=article-cover-03&orientation=landscape",
    author: "曼琳",
    date: "2026-07-22",
    readTime: "7分钟",
    tags: ["职场女性", "女性友谊", "职场关系"],
  },
  {
    slug: "guimi-lvxing-qushi",
    title: "闺蜜旅行必备清单：那些让我们笑出眼泪的旅途故事",
    excerpt: "和闺蜜一起旅行是检验友情的试金石。从选错酒店到迷路在陌生城市，这些爆笑又温馨的旅行故事，记录了我们最真实的姐妹时光。",
    content: `<p>有人说，想知道一个人适不适合做你一辈子的朋友，就和TA一起去旅行。旅行中的压力、疲惫和意外，会把人最真实的一面暴露出来。幸运的是，我和我的闺蜜们在旅行中从没翻过脸，反而创造了无数笑料。</p>
    <h2>故事一：订错酒店的乌龙</h2>
    <p>那是我们第一次出国自由行，去清迈。小楠负责订酒店，她兴冲冲地说找到了一家超美的民宿，有泳池有花园。结果到了之后发现——她订的是三个月后的日期。</p>
    <p>我们在清迈的街头拖着行李箱，用蹩脚的英语一家一家问有没有空房。最后住进了一家家庭旅馆，房间小得两个行李箱都打不开。但那天晚上我们挤在一张床上，笑到肚子疼。现在每次聚在一起，\"小楠订酒店\"已经成了我们之间的经典笑话。</p>
    <h2>故事二：迷路在东京地下铁</h2>
    <p>东京的地铁系统复杂到令人崩溃。我们四个人，三个手机，两个导航APP，依然在新宿站迷路了将近一个小时。最后是我们中方向感最差的晓晓，随手指了一个出口，结果误打误撞走到了目的地。</p>
    <p>从此我们赋予了晓晓一个称号——\"直觉导航仪\"。虽然她自己也不知道那次是怎么走对的。</p>
    <h2>故事三：在巴厘岛一起大哭</h2>
    <p>旅行不全是欢乐。那次在巴厘岛，我和闺蜜小冉都刚经历了一些不太好的事情。有一天晚上我们在海滩上喝酒聊天，聊着聊着两个人都哭了。但哭完之后感觉很释放，好像把积攒了几个月的情绪都清空了。</p>
    <p>第二天我们起得很早去看日出，阳光照在海面上的时候，小冉对我说：\"谢谢你陪我来这里。\"我说：\"谢什么，以后你想去哪我都陪你。\"</p>
    <h2>闺蜜旅行黄金法则</h2>
    <p>1. 出发前把各自的预算说清楚，不要在钱上闹不愉快。</p>
    <p>2. 允许各自有独处的时间，不用全程绑在一起。</p>
    <p>3. 一个人负责规划，其他人负责服从——太多意见反而容易吵架。</p>
    <p>4. 留出意外的时间，最好的旅行记忆常常来自计划之外。</p>
    <p>5. 多拍照，这些照片十年后都是最珍贵的财富。</p>`,
    category: "quwei-gushi",
    coverImage: "https://readdy.ai/api/search-image?query=Three%20Chinese%20young%20women%20traveling%20together%20on%20a%20scenic%20coastal%20road%2C%20carrying%20backpacks%2C%20laughing%20and%20taking%20photos%2C%20golden%20sunset%20light%2C%20warm%20adventurous%20mood%2C%20cream%20and%20coral%20color%20palette&width=800&height=500&seq=article-cover-04&orientation=landscape",
    author: "小冉",
    date: "2026-07-18",
    readTime: "9分钟",
    tags: ["闺蜜旅行", "旅行故事", "姐妹时光"],
  },
  {
    slug: "chengzhang-jilu",
    title: "十年闺蜜成长录：从校园到职场，我们都在变好",
    excerpt: "从学生时代的青涩到职场中的从容，十年的友谊见证了彼此的成长与蜕变。这是一份跨越十年的姐妹成长记录。",
    content: `<p>翻看十年前的照片，我们都笑了。那时候的我们穿着现在看来土得不行的衣服，留着现在看来傻得不行的发型。但眼中那份对未来的期待，和现在一模一样。</p>
    <h2>大学时代：最纯粹的友谊</h2>
    <p>大学四年是我们友谊的起点。一起在图书馆占座，一起在食堂吐槽饭菜，一起在宿舍熬夜追剧，一起在期末考前疯狂背书。</p>
    <p>那时候我们没有钱，但有时间。周末能去逛个街吃个麻辣烫就开心得要命。生日礼物互相送手工做的卡片和几十块钱的小饰品，但每一样都珍藏到现在。</p>
    <h2>毕业后：各奔东西却从未走散</h2>
    <p>毕业后我们散落到了不同的城市。刚开始工作那段时间最艰难——工资低、压力大、对新环境的各种不适应。但我们的群里永远有人在说话，分享面试经历、吐槽奇葩同事、互相推荐工作机会。</p>
    <p>诗涵是我们中最早结婚的。婚礼那天，我们几个当伴娘，在化妆间里哭成一团。不是伤心的眼泪，是开心——看到最好的朋友找到幸福，那种心情比什么都珍贵。</p>
    <h2>现在：我们都成为了更好的自己</h2>
    <p>十年过去了。有人成了部门主管，有人开了自己的工作室，有人当了妈妈。我们不再是十年前那个对未来迷茫的小女生了。但有些东西没变——我们依然会在群里分享生活中的小确幸，依然会在有人难过时第一时间出现。</p>
    <p>去年十一我们搞了一次十周年聚会，每个人准备了一个主题分享。我分享的是“感谢你们见证了我最糟糕的样子，也看到我现在最好的样子”——说完大家都哭了。</p>`,
    category: "chengzhang-jianzheng",
    coverImage: "https://readdy.ai/api/search-image?query=Group%20of%20Chinese%20women%20friends%20toasting%20with%20wine%20glasses%20at%20a%20dinner%20party%2C%20warm%20intimate%20gathering%2C%20celebrating%20friendship%2C%20soft%20candlelight%2C%20elegant%20setting%2C%20cream%20and%20blush%20warm%20tones&width=800&height=500&seq=article-cover-05&orientation=landscape",
    author: "诗涵",
    date: "2026-07-15",
    readTime: "7分钟",
    tags: ["成长故事", "十年友谊", "青春"],
  },
  {
    slug: "jiankang-guimi-guangxi",
    title: "如何辨别\"有毒\"的闺蜜关系？这5个信号要警惕",
    excerpt: "不是所有的闺蜜关系都是健康的。识别那些消耗你能量、让你不开心的\"有毒\"友谊，学会保护自己的情感边界。",
    content: `<p>我们常常关注恋爱中的“有毒关系”，却很少讨论友谊中同样存在的问题。事实上，一段不健康的闺蜜关系，对人的消耗可能比一段糟糕的恋爱更隐蔽也更持久。</p>
    <h2>信号一：她只在需要你的时候出现</h2>
    <p>你有没有这样的朋友？她失恋时一天给你打十个电话，你陪她哭陪她骂陪她吃夜宵。但当你遇到困难找她的时候，她总是“在忙”、“不方便”、“改天聊”。</p>
    <p>这种关系不是友谊，而是情感上的单向索取。她不关心你的生活，只把你当做情绪垃圾桶。久而久之，你会感到自己被掏空。</p>
    <h2>信号二：她总是贬低你</h2>
    <p>“你这件衣服也太显胖了吧哈哈”、“你的新工作也就那样吧”、“你男朋友对你这么好，是不是有什么问题”——这些话听起来像是玩笑，但说多了，你会开始怀疑自己。</p>
    <p>真正关心你的闺蜜会让你更有自信，而不是通过贬低你来抬高她自己。如果你发现和她相处完之后总是心情低落，那可能不是你的问题。</p>
    <h2>信号三：她在背后说其他朋友的坏话</h2>
    <p>如果一个女生在你面前把另一个朋友说得一无是处，那你基本可以确定——她在另一个朋友面前也是这样说你。</p>
    <p>真正的友谊建立在信任的基础上。习惯性搬弄是非的人，不值得你交付真心。</p>
    <h2>信号四：她嫉妒你的成功</h2>
    <p>你升职了，她说“运气真好”；你恋爱了，她说“别太投入”；你变美了，她说“花了不少钱吧”。在你的每个高光时刻，她都会泼一盆冷水。</p>
    <p>健康的友谊中，你的成功就是她的快乐。如果她的反应总是让你的喜悦减半，你需要重新审视这段关系。</p>
    <h2>信号五：她让你违背自己的价值观</h2>
    <p>怂恿你做你不愿意做的事、在道德边缘试探、让你为了“够朋友”而伤害其他人——这些都不是友谊，是操控。</p>
    <p>保护好自己，远离那些让你变得不像自己的人。真正的闺蜜会让你成为更好的自己，而不是更糟。</p>`,
    category: "qinggan-zhinan",
    coverImage: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20sitting%20alone%20by%20a%20window%20in%20thoughtful%20contemplation%2C%20soft%20morning%20light%20streaming%20through%20curtains%2C%20reflective%20mood%2C%20cream%20and%20warm%20neutral%20tones%2C%20editorial%20portrait%20style&width=800&height=500&seq=article-cover-06&orientation=landscape",
    author: "心怡",
    date: "2026-07-12",
    readTime: "6分钟",
    tags: ["情感健康", "有毒关系", "自我成长"],
  },
  {
    slug: "jiehun-hou-guimi",
    title: "结婚后如何维系闺蜜关系？已婚女性的友谊保鲜法",
    excerpt: "结婚生子后，很多女性发现和闺蜜的联系越来越少了。如何在家庭生活的忙碌中为友谊留出一席之地？这里有一些实用的建议。",
    content: `<p>“自从结了婚，我的社交圈就只剩下老公和同事了。”这句话说出了很多已婚女性的心声。婚前无话不谈的闺蜜，婚后渐渐变成了朋友圈的点赞之交。</p>
    <p>但友情不应该因为婚姻而凋零。相反，一段健康的婚姻，应该容纳你的人际关系，而不是取代它们。</p>
    <h2>闺蜜的“季度约会”制度</h2>
    <p>我和三个闺蜜约定了一个“季度约会”制度——每个季度至少有一次完整的闺蜜日。这一天我们不谈老公、不谈孩子、不谈家务，只做我们自己想做的事情。</p>
    <p>有时候是SPA和下午茶，有时候是一起看展，有时候只是窝在一个人家里看老电影吃零食。重要的是，这一天完全属于我们自己。</p>
    <h2>找一个理解你的伴侣</h2>
    <p>我老公非常支持我和闺蜜们保持联系。他说：“你和她们在一起的时候最放松，回来之后心情也最好。我看到你开心，我也开心。”</p>
    <p>如果你的伴侣总是抱怨你和朋友出去玩，不妨和他好好聊聊。告诉他，你的朋友不是你婚姻的威胁，而是你情感世界的补充。一个完整的你不止是妻子和母亲，也是一个有自己朋友的人。</p>
    <h2>把闺蜜变成“家人”</h2>
    <p>我们几个闺蜜的孩子们互相叫“干妈”，逢年过节一起聚餐。我们的老公们也渐渐成了朋友——虽然他们聚在一起主要是一起吐槽我们。</p>
    <p>当闺蜜成了家人，聚会就不需要特意安排了。周末一起吃个饭、一起遛娃、一起逛超市，自然得就像呼吸一样。</p>`,
    category: "gurien-xiangchu",
    coverImage: "https://readdy.ai/api/search-image?query=Two%20Chinese%20women%20with%20their%20children%20having%20a%20playdate%20in%20a%20sunny%20living%20room%2C%20warm%20family%20atmosphere%2C%20natural%20interaction%2C%20soft%20cream%20and%20blush%20tones%2C%20lifestyle%20photography&width=800&height=500&seq=article-cover-07&orientation=landscape",
    author: "雅婷",
    date: "2026-07-08",
    readTime: "5分钟",
    tags: ["已婚女性", "友谊维系", "家庭与友情"],
  },
  {
    slug: "xin-renshi-guimi",
    title: "30岁之后还能交到真正的闺蜜吗？答案出乎意料",
    excerpt: "很多人觉得成年后很难交到真心朋友。但事实恰恰相反——30岁以后的友谊，往往比青春期的友谊更加成熟和珍贵。",
    content: `<p>“到了一定年纪，朋友只会越来越少。”这句话你一定听过很多次。但我想说，这句话只说对了一半——老朋友也许会渐行渐远，但新朋友同样可以走进你的生命。</p>
    <h2>30岁后交友的逻辑变了</h2>
    <p>青春期的友谊建立在“一起做过什么”上——一起上学、一起逛街、一起暗恋。而成年后的友谊建立在“价值观相似”上——对生活的理解、对自我的认知、对未来的期待。</p>
    <p>后者看起来更难，因为筛选标准更高了。但也正因为如此，一旦找到，这段友谊的质量往往更高。</p>
    <h2>我的亲身经历</h2>
    <p>我在32岁那年认识了现在的闺蜜楠楠。我们是在一个瑜伽课上认识的，下课后一起去喝了杯果汁。聊着聊着发现，我们都刚经历了一段不太好的感情，都在重新学习如何与自己相处。</p>
    <p>那天我们在果汁店坐了三个多小时。不是说个不停，也有很多安静的停顿，但那种舒适感就像认识很久了一样。</p>
    <p>现在我们已经做了三年闺蜜了。她见证了我结婚生子，我陪伴了她创业打拼。我们会一起吐槽社会对30+女性的各种刻板印象，也会一起规划40岁要去哪里旅行。</p>
    <h2>成年后交友的三个机会</h2>
    <p><strong>兴趣社群：</strong>瑜伽课、烘焙班、读书会、户外徒步……共同的爱好是成年人交友最好的切入点。</p>
    <p><strong>职场：</strong>虽然前面说过职场友谊要小心，但不可否认，很多深厚的友谊都是从同事关系开始的。</p>
    <p><strong>妈妈群：</strong>如果你有孩子，妈妈群是一个天然的交友平台。但不建议只聊育儿，试着找到那些愿意聊自己、聊生活的妈妈。</p>`,
    category: "jiemei-qinggan",
    coverImage: "https://readdy.ai/api/search-image?query=Two%20mature%20Chinese%20women%20around%2030%20practicing%20yoga%20together%20in%20a%20bright%20studio%2C%20sunlight%20streaming%20through%20large%20windows%2C%20peaceful%20and%20empowering%20atmosphere%2C%20cream%20and%20sage%20green%20tones&width=800&height=500&seq=article-cover-08&orientation=landscape",
    author: "楠楠",
    date: "2026-07-05",
    readTime: "6分钟",
    tags: ["成年交友", "30岁", "女性成长"],
  },
  {
    slug: "guimi-jieri-liwu",
    title: "闺蜜生日送什么？从50元到500元的心意之选",
    excerpt: "选闺蜜的生日礼物，不一定要多贵，但一定要有心。这份不同价位的礼物清单，帮你送出最有心意的姐妹礼物。",
    content: `<p>闺蜜生日快到了，你是不是又在为送什么而纠结？别担心，我整理了这份从平价到轻奢的礼物清单，每一件都是我亲自买过或者收到过、确认会让女生心动的选择。</p>
    <h2>50元以内：心意满分</h2>
    <p>一张手写贺卡 + 一束小花：不要小看手写的力量。在这个什么都是电子化的时代，亲手写的祝福最珍贵。</p>
    <p>一本她喜欢的书 + 你写的推荐语：在扉页上写下为什么推荐这本书给她，让她每次翻开都能想起你。</p>
    <h2>50-200元：实用又有品</h2>
    <p>香薰蜡烛或扩香石：选一个她喜欢的香味，每次闻到都会想起你。</p>
    <p>定制手机壳：放上你们的合照或者她喜欢的图案，独一无二。</p>
    <p>一杯好喝的茶或咖啡豆：如果她是茶或咖啡爱好者，一份高品质的饮品会让她每天享用的时候都想起你。</p>
    <h2>200-500元：品质之选</h2>
    <p>一条简约的银饰项链：最好是能刻字的，刻上你们的专属暗号或日期。</p>
    <p>一瓶她种草已久的香水小样套装：送正装怕踩雷，小样套装可以让她自己选最爱的那一款。</p>
    <p>SPA或美容体验券：送她一段完全属于自己的放松时光。</p>
    <h2>最重要的原则</h2>
    <p>礼物好不好，不在价格，而在你是否了解她。一个用心挑选的50元的礼物，比随手买的500元的礼物珍贵一百倍。因为前者代表“我懂你”，后者只是“我有钱”。</p>`,
    category: "gurien-xiangchu",
    coverImage: "https://readdy.ai/api/search-image?query=Beautifully%20wrapped%20gift%20boxes%20with%20ribbons%20on%20a%20wooden%20table%2C%20surrounded%20by%20fresh%20flowers%20and%20dried%20botanicals%2C%20soft%20natural%20light%2C%20warm%20cream%20and%20blush%20aesthetic%2C%20flat%20lay%20photography&width=800&height=500&seq=article-cover-09&orientation=landscape",
    author: "小米",
    date: "2026-07-01",
    readTime: "5分钟",
    tags: ["礼物推荐", "闺蜜生日", "送礼指南"],
  },
  {
    slug: "yigeren-ye-henhao",
    title: "一个人的时候也很好：学会和自己做朋友",
    excerpt: "在寻找和经营闺蜜关系的同时，别忘了最重要的一段关系——和自己的关系。学会独处，是成为一个好闺蜜的基础。",
    content: `<p>我们花了很多时间和精力去维护和闺蜜的关系，但有时候我们忘了，人生中最长的一段关系，不是和任何人，而是和自己。</p>
    <h2>独处不等于孤独</h2>
    <p>很多人害怕独处，因为独处的时候要面对自己——那些积压的情绪、未解决的问题、不愿承认的事实，都会在安静的时候浮现出来。</p>
    <p>但独处和孤独是两回事。孤独是一种缺失感，而独处是一种选择。当你主动选择和自己相处，你会发现那是一种自由。</p>
    <h2>学会和自己相处的三个练习</h2>
    <p><strong>一个人的约会：</strong>每周给自己安排一次“一个人约会”——去看一场电影、吃一顿喜欢的饭、逛一家有趣的小店。不需要迁就任何人，完全按照自己的节奏来。</p>
    <p><strong>写日记：</strong>不需要每天写，但当你情绪起伏比较大的时候，试着把感受写下来。写下让你开心或难过的事情，然后问问自己：为什么这件事会让我有这种感觉？</p>
    <p><strong>独处时做创造性的活动：</strong>画画、做手工、弹乐器、种花——这些不需要别人参与的活动，会让你进入一种“心流”状态。在那个状态里，时间消失了，焦虑也消失了。</p>
    <h2>一个会和自己相处的人，也会是更好的闺蜜</h2>
    <p>当你学会了和自己友好相处，你就不会把所有的情感需求都压在闺蜜身上。你不会因为没有回消息而焦虑，不会因为她和别人出去玩而嫉妒。因为你有一个丰富而完整的内心世界。</p>
    <p>最好的友谊，是两个完整的圆相遇，而不是两个半圆拼在一起。</p>`,
    category: "chengzhang-jianzheng",
    coverImage: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20enjoying%20a%20peaceful%20moment%20alone%20at%20a%20cozy%20cafe%20corner%2C%20reading%20a%20book%20with%20warm%20coffee%2C%20soft%20window%20light%2C%20content%20and%20serene%20expression%2C%20cream%20and%20golden%20warm%20tones&width=800&height=500&seq=article-cover-10&orientation=landscape",
    author: "知夏",
    date: "2026-06-28",
    readTime: "5分钟",
    tags: ["自我成长", "独处", "女性力量"],
  },
];

export const featuredArticleSlugs = [
  "zhenshi-guimi-guangxi",
  "guimi-xiangchu-zhidao",
  "guimi-lvxing-qushi",
];

export const testimonials = [
  {
    name: "小雨",
    age: 28,
    city: "上海",
    content: "这个网站让我意识到，原来我并不是一个人。看到那么多女生分享的闺蜜故事，我决定主动联系了大学时的好朋友，现在我们每周都会视频聊天。",
  },
  {
    name: "晓琳",
    age: 32,
    city: "北京",
    content: `那篇关于“有毒闺蜜”的文章点醒了我。我一直困惑为什么每次和某个朋友见面后都觉得累，现在我懂了。谢谢你们帮我看清楚。`,
  },
  {
    name: "佳怡",
    age: 25,
    city: "广州",
    content: "闺蜜旅行那篇文章笑死我了！我们几个闺蜜也有类似的经历——订错机票日期，结果在机场傻等了一天。把这些故事分享出来真的很有共鸣！",
  },
];

export const siteInfo = {
  name: "美女搞基",
  tagline: "女生之间最真实的闺蜜情谊",
  description: "美女搞基，指女生之间亲密无间的闺蜜情谊与姐妹情感。探索现代女性友谊的真实面貌，了解如何建立深厚的姐妹情，分享闺蜜相处趣事与情感故事，感受女生之间最纯粹的友情力量。",
  keywords: "美女搞基,闺蜜情谊,女生友情,姐妹情,闺蜜相处,女生情感,闺蜜故事",
  email: "hello@meinvgaoji.com",
  socialLinks: {
    weibo: "#",
    wechat: "#",
    xiaohongshu: "#",
  },
};